import { Card } from './components';

export function Main() {
  return (
    <div className="w-full min-h-screen grid place-items-center bg-slate-200">
      <Card />
    </div>
  );
}
